// Dumb dialog — no store, no SQL, no DuckDB.
//
//   props:  modelValue (Boolean)  v-model for the open state
//           exporting  (Boolean)  drives the export button's loading spinner
//           query      (Object)   OPT-IN (AM_ABSORPTION_PLAN F1), default null: the SQL runner —
//                                 standalone asset-management's dialog body (a SQL textarea, Run +
//                                 Ctrl/Cmd+Enter, shortcut buttons, the error alert, the result
//                                 table capped at 200 rows). The APP supplies everything that
//                                 touches DuckDB:
//                                   run(sql)    → Promise<rows | { columns?, rows }> — rows are
//                                                 plain objects keyed by column (Arrow rows
//                                                 already `toJSON()`ed); a rejection's message
//                                                 is shown in the alert
//                                   shortcuts?  [{ label, sql }] — label already translated;
//                                                 a click puts `sql` in the textarea
//                                   initialSql? the textarea's first text
//                                 null ⇒ the dialog renders exactly as before F1 (the title bar
//                                 with the export button, nothing else)
//   emits:  update:modelValue     open/close
//           export                the parent runs the export (useDuckDBExport)
//
// Strings come from the colocated ./messages folder through a LOCAL composer
// (rule 11) — the app's bundle carries neither key. See ./setup.js.
import setup from './setup.js';

const isShortcut = (s) => !!s && typeof s.label === 'string' && typeof s.sql === 'string';

export default {
  name: 'duckdb-query-dialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    exporting: {
      type: Boolean,
      default: false,
    },
    query: {
      type: Object,
      default: null,
      validator: (q) => q === null || (
        typeof q.run === 'function'
        && (q.shortcuts == null || (Array.isArray(q.shortcuts) && q.shortcuts.every(isShortcut)))
        && (q.initialSql == null || typeof q.initialSql === 'string')
      ),
    },
  },
  emits: ['update:modelValue', 'export'],
  setup,
};
